/**
 * Base URL for consent Cancel (return user to linking entry with query preserved).
 * Override with REACT_APP_CANCEL_REDIRECT_BASE in .env if needed.
 */
export function getCancelRedirectBase() {
  return (process.env.REACT_APP_CANCEL_REDIRECT_BASE || 'https://voice-login.iot.sharkninja.com').replace(
    /\/+$/,
    ''
  );
}
